import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export const useHasValidNylasAccount = (): boolean => {
  const { me } = useAppData();
  const nylasAccount = me?.nylas_account?.[0];
  return nylasAccount != null && !nylasAccount.invalid;
};
